import { useEffect } from "react";
import Footerr from "../components/Footerr/Footerr";
import { Team } from "../components/home";
import { Header } from "../components/shared";
import usePageMeta from "../../seo/usePageMeta";


function TeamPage() {
  usePageMeta({
    title: "Meet the Team | Terces Solutions",
    description:
      "Meet the consultants and operators behind Terces Solutions — the team helping restaurants build scalable, profitable systems.",
    path: "/Team",
  });

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="team-page">
      <Header />
      <main className="team-content">
        <Team />

      </main>
      <Footerr />
    </div>
  );
}

export default TeamPage;
